var map = {
	"./noble01/客服@2x.png": "e626",
	"./noble02/客服@2x.png": "2a3a",
	"./noble03/客服@2x.png": "ef1a",
	"./noble04/客服@2x.png": "6adf",
	"./noble05/客服@2x.png": "b929"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f40d";